import { useQuery } from "@tanstack/react-query";
import { hub } from "@/lib/hub-client";

export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  icon: string | null;
  sort_order: number;
}

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const res = await hub.GET<{ items: Category[] }>("/v1/categories");
      if (!res.data) throw new Error("categories fetch failed");
      return res.data.items;
    },
    staleTime: 10 * 60 * 1000, // 10 min — matches edge cache
  });
}
